if (!customElements.get('freniz-product')) {
  customElements.define('freniz-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const gallery = this.querySelector('.frz-gallery');
      const thumbs = this.querySelectorAll('.frz-thumb');
      const sticky = this.querySelector('[data-sticky]');
      const form = this.querySelector('.frz-purchase');
      const add = this.querySelector('[data-add]');
      const choice = this.querySelector('[data-variant]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const showMedia = (id) => {
        const target = this.querySelector('[id="frz-media-' + this.dataset.section + '-' + id + '"]');
        if (target && gallery) gallery.scrollTo({left:target.offsetLeft - gallery.offsetLeft,behavior:reduce ? 'instant' : 'smooth'});
      };
      thumbs.forEach(thumb => thumb.addEventListener('click', event => {
        event.preventDefault();
        showMedia(thumb.dataset.media);
      }));
      if (gallery && 'IntersectionObserver' in window) {
        this.mediaObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const id = entry.target.id.split('-').pop();
            thumbs.forEach(thumb => {
              if (thumb.dataset.media === id) thumb.setAttribute('aria-current','true');
              else thumb.removeAttribute('aria-current');
            });
          });
        },{root:gallery,threshold:0.6});
        this.querySelectorAll('.frz-media').forEach(media => this.mediaObserver.observe(media));
      }
      if (form && sticky && 'IntersectionObserver' in window) {
        this.buyObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        },{threshold:0});
        this.buyObserver.observe(form);
      }
      if (choice) choice.addEventListener('change', () => {
        const option = choice.selectedOptions[0];
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-price]').forEach(price => price.textContent = option.dataset.price);
        this.querySelectorAll('[data-compare]').forEach(price => {
          price.textContent = option.dataset.compare;
          price.hidden = option.dataset.sale !== 'true';
        });
        this.querySelectorAll('[data-add]').forEach(button => {
          button.disabled = !available;
          button.textContent = available ? button.dataset.ready : button.dataset.sold;
        });
        if (option.dataset.image) showMedia(option.dataset.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', choice.value);
        window.history.replaceState({}, '', url);
      });
      if (form) form.addEventListener('submit', event => {
        event.stopImmediatePropagation();
        const button = event.submitter || add;
        if (button && button.disabled) event.preventDefault();
      },true);
    }
    disconnectedCallback() {
      if (this.mediaObserver) this.mediaObserver.disconnect();
      if (this.buyObserver) this.buyObserver.disconnect();
      this.initialized = false;
    }
  });
}

